// Created by jarongallo at 6/17/21
import React, { useEffect, useState } from 'react';
import PLTable from '../../../../../../components/PL/PLTable/PLTable';
import { AGENTS_TABLE_TYPE, SALESMEN_TABLE_TYPE } from '../../../../../../components/PL/PLTable/config';
import { useLazyQuery } from '@apollo/react-hooks';
import { GET_SALESPERSON_NAME, GET_SIGNED_UP_AGENTS } from './queries';
import { getPaginatedTableVariablesByTypeAndSearchTypeScript } from '../../../../../../components/PL/PLTable/TypeScriptHelpers';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getFiltersProp } from '../../../../../../redux/selectors/CurrentUserSelectors';
import * as strings from './strings';

export default function IndividualSalespersonAgentsTab({ salespersonId }: IndividualSalespersonAgentsTabProps) {
	let QUERY_LIMIT = 50;

	const history = useHistory();
	const filters = useSelector(getFiltersProp);
	const location = useLocation();
	let props = {
		filters,
		location
	};

	const [salesperson, setSalesperson] = useState<UserType>();
	const [signupUsers, setSignupUsers] = useState<UserType[]>([]);

	let baseVariables = {
		query: {
			salespersonId: salespersonId
		}
	};
	let variables = getPaginatedTableVariablesByTypeAndSearchTypeScript(QUERY_LIMIT, AGENTS_TABLE_TYPE, props, baseVariables);

	const [getSignedUpAgents, { data: signedUpAgentsData }] = useLazyQuery(GET_SIGNED_UP_AGENTS, {
		variables
	});

	const [getSalespersonName, { data: salespersonData }] = useLazyQuery(GET_SALESPERSON_NAME, {
		variables: { id: salespersonId }
	});

	useEffect(() => {
		(async () => {
			await getSalespersonName();
		})();
	}, []);

	useEffect(() => {
		(async () => {
			if (salespersonData) {
				setSalesperson(salespersonData['user']);
				await getSignedUpAgents();
			}
		})();
	}, [salespersonData]);

	useEffect(() => {
		(async () => {
			if (signedUpAgentsData) {
				const fetchedAgents: UserType[] = signedUpAgentsData['users'];
				setSignupUsers(fetchedAgents);
			}
		})();
	}, [signedUpAgentsData]);

	if (!salesperson) return null;

	return (
		<PLTable
			emptySetText={`${salesperson.name}${strings.emptySetSignups}`}
			type={SALESMEN_TABLE_TYPE}
			limit={50}
			updateTable={getSalespersonName}
			data={signupUsers}
			onSelect={(agent) => history.push('/agent/' + agent.id)}
		/>
	);
}
